import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "o-container" }
const _hoisted_2 = { class: "o-form" }
const _hoisted_3 = { class: "o-form__item__container" }
const _hoisted_4 = { class: "o-form__item" }
const _hoisted_5 = {
  class: "o-label sr-only",
  for: "programmes-search"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-search",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "search"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search" })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "o-form__item" }
const _hoisted_9 = {
  class: "o-label sr-only",
  for: "category"
}
const _hoisted_10 = { value: "" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_13 = { class: "o-form__item" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_18 = { class: "o-form__item" }
const _hoisted_19 = {
  class: "o-label sr-only",
  for: "programme"
}
const _hoisted_20 = { value: "" }
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_23 = { class: "c-programmes-search__filters" }
const _hoisted_24 = { class: "o-container" }
const _hoisted_25 = { class: "c-programmes-search__filters__wrap" }
const _hoisted_26 = { class: "c-programmes-search__filters__total" }
const _hoisted_27 = {
  key: 0,
  class: "c-programmes-search__filters__actives"
}
const _hoisted_28 = { class: "c-programmes-search__filters__actives__item" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_32 = { class: "sr-only" }
const _hoisted_33 = {
  key: 1,
  class: "c-programmes-search__filters__reset"
}
const _hoisted_34 = { class: "o-container" }
const _hoisted_35 = {
  ref: "resultsStart",
  class: "c-projects-search__results"
}
const _hoisted_36 = { class: "c-search-results__item -show" }
const _hoisted_37 = { class: "c-search-result__header" }
const _hoisted_38 = { class: "c-search-result__title o-title-4" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "c-search-result__desc" }
const _hoisted_41 = {
  key: 0,
  class: "c-search-result__tags"
}
const _hoisted_42 = { class: "o-tag" }
const _hoisted_43 = { class: "o-tag" }
const _hoisted_44 = { class: "o-tag" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pager = _resolveComponent("Pager")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-programmes-search", [$props.background]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString($options.t("Mots clés")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("input", {
                onKeyup: _cache[0] || (_cache[0] = $event => ($options.keyupSearch())),
                class: "o-input",
                id: "programmes-search",
                type: "text",
                placeholder: $options.t('Mots clés'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.searchInput) = $event))
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
                [_vModelText, $data.searchInput]
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString($options.t("Catégories")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[2] || (_cache[2] = $event => ($options.changeSelectionCategory())),
                class: "o-select",
                id: "category",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedCategory) = $event))
              }, [
                _createElementVNode("option", _hoisted_10, _toDisplayString($options.t("Catégories")), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categories, (category) => {
                  return (_openBlock(), _createElementBlock("option", { value: category }, _toDisplayString(category), 9 /* TEXT, PROPS */, _hoisted_11))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, $data.selectedCategory]
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", {
                class: "o-label sr-only",
                for: "champs",
                innerHTML: $options.t('Champs d\'intérêt')
              }, null, 8 /* PROPS */, _hoisted_14),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[4] || (_cache[4] = $event => ($options.changeSelectionChamp())),
                class: "o-select",
                id: "champs",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedChamp) = $event))
              }, [
                _createElementVNode("option", {
                  value: "",
                  innerHTML: $options.t('Champs d\'intérêt')
                }, null, 8 /* PROPS */, _hoisted_15),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.champs, (champ) => {
                  return (_openBlock(), _createElementBlock("option", { value: champ }, _toDisplayString(champ), 9 /* TEXT, PROPS */, _hoisted_16))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, $data.selectedChamp]
              ]),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString($options.t("Programmes")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[6] || (_cache[6] = $event => ($options.changeSelectionProgramme())),
                class: "o-select",
                id: "programme",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.selectedProgramme) = $event))
              }, [
                _createElementVNode("option", _hoisted_20, _toDisplayString($options.t("Programmes")), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.programmes, (programme) => {
                  return (_openBlock(), _createElementBlock("option", { value: programme }, _toDisplayString(programme), 9 /* TEXT, PROPS */, _hoisted_21))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, $data.selectedProgramme]
              ]),
              _hoisted_22
            ]),
            _createCommentVNode("<div class=\"o-form__button c-tooltip__wrap\">\n                        <button class=\"o-button -button-bg\" type=\"submit\">\n                            <span class=\"o-button__icos\">\n                                <span class=\"o-button__ico\">\n                                    <svg class=\"o-ico -ico-arrow-full-right\" role=\"img\">\n                                        <title>arrow-full-right</title>\n                                        <use xlink:href=\"/assets/img/sprite.svg?v=2#arrow-full-right\"></use>\n                                    </svg>\n                                </span>\n                                <span class=\"o-button__ico\">\n                                    <svg class=\"o-ico -ico-arrow-full-right\" role=\"img\">\n                                        <title>arrow-full-right</title>\n                                        <use xlink:href=\"/assets/img/sprite.svg?v=2#arrow-full-right\"></use>\n                                    </svg>\n                                </span>\n                            </span>\n                            <span class=\"o-button__text\">\n                                <span class=\"o-button__text__elm\">\n                                    {{ t(\"Rechercher\") }} <span class=\"sr-only\">{{ t(\"un club selon les critères sélectionnés\") }}</span>\n                                </span>\n                            </span>\n                        </button>\n\n                        <div class=\"c-tooltip\">\n                            <span class=\"c-tooltip__text\">\n                                {{ t(\"Voir les\") }} {{ filteredResults.length }} {{ t(\"résultat\") }}{{ filteredResults.length > 1 ? 's' : '' }}\n                            </span>\n                        </div>\n                    </div>")
          ])
        ])
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", null, _toDisplayString($options.filteredResults.length) + " " + _toDisplayString($options.t("résultat")) + _toDisplayString($options.filteredResults.length > 1 ? 's' : ''), 1 /* TEXT */)
          ]),
          ($options.tags.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("span", null, _toDisplayString(tag.title), 1 /* TEXT */),
                    _createElementVNode("button", {
                      onClick: _withModifiers($event => ($options.removeTag(tag)), ["prevent"]),
                      class: "c-programmes-search__filters__remove"
                    }, [
                      _hoisted_30,
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString($options.t("Retirer le filtre")) + " : " + _toDisplayString(tag.title), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_29)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($options.tags.length>0 || $data.searchInput.length>0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = _withModifiers($event => ($options.resetSearch()), ["prevent"])),
                  class: "o-button -button-reset"
                }, _toDisplayString($options.t("Réinitialiser la recherche")), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["o-section__inner", {'-loading': $data.loading}])
    }, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredResultsPaged, (entry) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", _hoisted_38, [
                  _createElementVNode("a", {
                    href: entry.url
                  }, _toDisplayString(entry.title), 9 /* TEXT, PROPS */, _hoisted_39)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("p", null, _toDisplayString(entry.description), 1 /* TEXT */)
              ]),
              (entry.categories.length || entry.champs.length || entry.programmes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.categories, (category) => {
                      return (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(category.replace(/<[^>]*>?/gm, '')), 1 /* TEXT */))
                    }), 256 /* UNKEYED_FRAGMENT */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.champs, (champ) => {
                      return (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(champ.replace(/<[^>]*>?/gm, '')), 1 /* TEXT */))
                    }), 256 /* UNKEYED_FRAGMENT */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.programmes, (programme) => {
                      return (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(programme.replace(/<[^>]*>?/gm, '')), 1 /* TEXT */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */),
        ($options.totalPages>1)
          ? (_openBlock(), _createBlock(_component_Pager, {
              key: 0,
              pagerInfo: {'totalPages': $options.totalPages, 'currentPage': $data.currentPage},
              onGoToPage: $options.goToPage
            }, null, 8 /* PROPS */, ["pagerInfo", "onGoToPage"]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}